import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material'
import { AdminMainDashboardProps } from './props'
import MenuIcon from '@mui/icons-material/Menu'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import AdminMainSidebar from '../AdminMainSidebar'
import { useEffect } from 'react'
import adminPagesStore from '../../../store/adminPagesStore'
import AuthProvider from '../../../hooks/Providers/Auth'
import AdminGuard from '../AdminGuard'
import HomeIcon from '@mui/icons-material/Home'
import { Link, useNavigate } from 'react-router'
import links from '../../../routes/links'

const SIDEBAR_WIDTH = 300

export default function AdminMainContainer(props: AdminMainDashboardProps) {
  const theme = useTheme()
  const upMd = useMediaQuery(theme.breakpoints.up('md'))
  const navigate = useNavigate()

  const openSidebar = adminPagesStore(state => state.openSidebar)

  useEffect(() => {
    if (upMd) adminPagesStore.setState({ openSidebar: true })
    else adminPagesStore.setState({ openSidebar: false })
  }, [upMd])

  return (
    <AuthProvider>
      <AdminGuard>
        <AdminMainSidebar sidebarWidth={SIDEBAR_WIDTH} sx={{ display: openSidebar ? 'block' : 'none' }} />
        <AppBar position='static'>
          <Toolbar>
            <Box sx={{ width: openSidebar && upMd ? SIDEBAR_WIDTH : 0 }} />
            {upMd ? null : (
              <IconButton
                size='large'
                edge='start'
                color='inherit'
                aria-label='menu'
                onClick={() => adminPagesStore.setState({ openSidebar: true })}
                sx={{ mr: 2 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {!!props.backButton && props.backButton.show ? (
              <IconButton
                size='large'
                edge='start'
                color='inherit'
                aria-label='menu'
                onClick={() => (!!props.backButton?.navigateTo ? navigate(props.backButton.navigateTo) : navigate(-1))}
                sx={{ mr: 2 }}
              >
                {props.backButton.icon ?? <ArrowBackIcon />}
              </IconButton>
            ) : null}
            <Typography variant='h5' sx={{ flexGrow: 1 }}>
              {props.title}
            </Typography>
            <Link to={links.public.home()} style={{ textDecoration: 'none', color: 'inherit' }}>
              <IconButton size='large' color='inherit'>
                <HomeIcon />
              </IconButton>
            </Link>
          </Toolbar>
        </AppBar>
        <Box sx={{ pl: `${openSidebar && upMd ? SIDEBAR_WIDTH : 0}px` }}>
          <Box sx={{ p: upMd ? 4 : 2, ...props.wrapperBoxSx }}>{props.children}</Box>
        </Box>
      </AdminGuard>
    </AuthProvider>
  )
}
